import { Box, Button, ButtonGroup, Stack, TextField } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import StudentTile from "../../../../features/core/StudentTile";
import { HomeworkCheckInfo, HomeworkDone } from "../../../../redux/homework/homeworkCheckSlice";
import { useState } from "react";
import { findHomeworkCommentRequest, homeworkCommentChange, HomeworkCommentChangeRequest, selectHomeworkCommentChange } from "../../../../redux/homework/homeworkCommentChangeSlice";
import { HomeworkInfo } from "../../../../redux/homework/homeworkSlice";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { LoadState } from "../../../../redux/common";
import { homeworkCheckChange, HomeworkCheckChangeRequest } from "../../../../redux/homework/homeworkCheckChangeSlice";
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

interface ContentProps {
    homework: HomeworkInfo;
    studentId: string;
    check?: HomeworkCheckInfo;
}

const HomeworkReviewCheckCell = (props: ContentProps) => {
    const { studentId } = props;
    const homeworkChanges = useAppSelector(selectHomeworkCommentChange);
    const dispatch = useAppDispatch();

    const [requestData, setRequestData] = useState({
        schoolId: props.homework.schoolId,
        classroomId: props.homework.classroomId,
        homeworkId: props.homework.id,
        studentId: studentId,
        done: props.check?.done || HomeworkDone.No
    } as HomeworkCheckChangeRequest);

    const request = findHomeworkCommentRequest(homeworkChanges.requests, requestData);
    const state = request?.state.state || LoadState.NotStarted;

    return (
        <Stack direction="row" alignItems="center" spacing={1}>
            <Button 
                color={state == LoadState.Loading ? undefined : "success"}
                onClick={() => {
                    const data = { ...requestData, done: HomeworkDone.Yes };
                    dispatch( homeworkCheckChange(data) );
                }}
                variant={ props.check?.done == HomeworkDone.Yes ? "contained" : "outlined" }
                disabled={state == LoadState.Loading}>
                <DoneIcon />
            </Button>
            <Button 
                color={state == LoadState.Loading ? undefined : "error"}
                onClick={() => {
                    const data = { ...requestData, done: HomeworkDone.No };
                    dispatch( homeworkCheckChange(data) );
                }}
                variant={ props.check?.done == HomeworkDone.No ? "contained" : "outlined" }
                disabled={state == LoadState.Loading}>
                <CloseIcon />
            </Button>
        </Stack>
    );
};

export default HomeworkReviewCheckCell;
